'use client'

import { useRouter } from 'next/router'
import * as React from 'react'

import { PageNumberPagination } from '@/components/common/page-number-pagination'

import { getTotalPages } from '@/utils/pagination'

interface PaginationComponentProps {
  itemCount: number
  pageSize: number
  currentPage: number
  totalPages?: number
  pageParam?: string
  onPageChange?: (page: number) => void
  disabled?: boolean
  className?: string
}

const PaginationComponent: React.FC<PaginationComponentProps> = ({
  currentPage,
  itemCount,
  pageSize,
  totalPages,
  pageParam = 'page',
  onPageChange,
  disabled = false,
  className,
}) => {
  const router = useRouter()
  const pageCount = totalPages ?? getTotalPages(itemCount, pageSize)

  const changePage = React.useCallback(
    (page: number) => {
      if (page < 1 || page > pageCount) {
        return
      }

      if (onPageChange) {
        onPageChange(page)
        return
      }

      const currentURL = new URL(window.location.href)
      currentURL.searchParams.set(pageParam, page.toString())
      router.replace(`${router.asPath.split('?')[0]}${currentURL.search}`, undefined, { shallow: true })
    },
    [onPageChange, pageCount, pageParam, router]
  )

  return (
    <PageNumberPagination
      currentPage={currentPage}
      totalPages={pageCount}
      onPageChange={changePage}
      disabled={disabled}
      className={className}
    />
  )
}

export default PaginationComponent
